import { solid } from "@areahub/icons";
import {
  Box,
  Collapse,
  HStack,
  Stack,
  StackProps,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp, FaMapMarkerAlt } from "react-icons/fa";

export interface DynamicLegendProps extends StackProps {
  legendRows: {
    icon: string;
    label: string;
    color: string | number;
  }[];

  inverted?: boolean;
}

export const DynamicLegend: React.FC<DynamicLegendProps> = ({
  legendRows,
  inverted,
  ...props
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  return (
    <Stack
      cursor="pointer"
      w="250px"
      onClick={onToggle}
      backdropBlur="blur(10px)"
      borderTopRadius="md"
      bg="rgba(255, 255, 255, 0.6)"
      sx={{
        table: {
          tableLayout: "fixed",
        },
        "tr, td, tbody": {
          borderColor: "transparent",
        },
        th: {
          borderBottom: "none",
        },
        "th:nth-of-type(1), .icon": {
          width: "24px",
          px: "0",
          textAlign: "center",
        },
      }}
      {...props}
    >
      <HStack
        w="full"
        px="4"
        justifyContent="space-between"
        py="2"
        borderTopRadius="md"
        bg="muiGreen.600"
        color="white"
      >
        <Text fontSize="lg" fontWeight="bold">
          Legend
        </Text>
        <Box as={isOpen ? FaChevronUp : FaChevronDown} />
      </HStack>
      <Collapse in={isOpen} animateOpacity>
        <TableContainer pl="2" borderBottomRadius="xl">
          <Table size="sm" variant="simple">
            <Thead>
              <Tr>
                <Th />
                <Th />
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td className="icon">
                  <Box as={FaMapMarkerAlt} color="blueGray.800" mx="auto" />
                </Td>
                <Td fontSize="xs">Queried location</Td>
              </Tr>
              {legendRows.map((row, idx) => (
                <Tr key={idx}>
                  <Td
                    className="icon"
                    bg={inverted ? "transparent" : (row.color as string)}
                    color={inverted ? (row.color as string) : "white"}
                  >
                    <Box as={solid[row.icon as keyof typeof solid]} />
                  </Td>
                  <Td fontSize="xs">{row.label}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Collapse>
    </Stack>
  );
};
